import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PostTradeService } from '../../post-trade.service';
import { ptUtilityApps } from '../../../lib/utility-apps';
import { UtilityAppsService } from '../../../shared-components/utility-apps/utility-apps.service';

@Component({
  selector: 'app-trade-review',
  templateUrl: './trade-review.component.html',
  styleUrls: ['./trade-review.component.scss'],
  standalone: false,
})
export class TradeReviewComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);
  private route = inject(Router);
  private uas = inject(UtilityAppsService);


  rights = [];
  unsubscribe: Subject<any> = new Subject();
  tradeId = '';
  gridConfig = {
    title: 'Transaction Monitor',
    gridName: 'TradeReviewGrid',
    showGridFilters: true,
    showFilterManager: true,
    manualSearch: true,
    searchButtonText: 'Update Search',
    showBulkActions: true,
    downloadGridButton: true,
    gridActionColumn: true,
    selectActionText: 'Select Trade',
    previewActionText: 'View Trade',
    showActionId: true,
    rowSelector: 'TradeID',
    gridType: 'trade',
    detailViewRoute: '/trade-review/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
    storeGridNav: true,
    defaultPageSize: 100,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade/TR',
    },
    {
      label: 'Transaction Monitor',
      link: 'trade-review',
    },
  ];

  ngOnInit(): void {
    this.uas.appsList.set(ptUtilityApps);
    this.rights = this.ss.get('rights');
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.tradeId = params.id;
          this.crumbConfig.push({
            label: this.tradeId,
            link: `trade-review/${this.tradeId}`,
          });
        } else {
          this.tradeId = '';
        }
      });

    if (this.rights.includes('PostTradeReadOnly')) {
      this.gridConfig.showBulkActions = false;
    }
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    const ssFilters = this.ss.get('TradeReviewGridFilters');
    const defaultview = {
      filter: [],
      sort: [],
    };

    if (!ssFilters) {
      defaultview.filter.push({
        ProcessedDate: {
          selected: ['30 days'],
        },
      });
    }

    const getHeaders = this.ptSvc.getPostGridSetup();

    return forkJoin([getHeaders]).pipe(
      map(([data1]) => ({ ...data1, defaultview }))
    );
  }

  getGridData(reqData) {
    return this.ptSvc.getPostTradeGridData(reqData);
  }
}
